import { render, staticRenderFns } from "./GenerateReportCards.vue?vue&type=template&id=1aa4f0ea&scoped=true&"
import script from "./GenerateReportCards.vue?vue&type=script&lang=js&"
export * from "./GenerateReportCards.vue?vue&type=script&lang=js&"
import style0 from "./GenerateReportCards.vue?vue&type=style&index=0&id=1aa4f0ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa4f0ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VBtn,VCard,VCardText,VDataTable,VDialog,VListItemSubtitle,VProgressLinear,VRating})
